"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var recaptcha_component_1 = require("./recaptcha/recaptcha.component");
exports.RecaptchaComponent = recaptcha_component_1.RecaptchaComponent;
var recaptcha_loader_service_1 = require("./recaptcha/recaptcha-loader.service");
exports.RecaptchaLoaderService = recaptcha_loader_service_1.RecaptchaLoaderService;
exports.RECAPTCHA_LANGUAGE = recaptcha_loader_service_1.RECAPTCHA_LANGUAGE;
var recaptcha_value_accessor_directive_1 = require("./recaptcha/recaptcha-value-accessor.directive");
exports.RecaptchaValueAccessorDirective = recaptcha_value_accessor_directive_1.RecaptchaValueAccessorDirective;
var recaptcha_module_1 = require("./recaptcha/recaptcha.module");
exports.RecaptchaModule = recaptcha_module_1.RecaptchaModule;



//////////////////
// WEBPACK FOOTER
// /home/backend/KreditCentr/WebLombard/client/~/ng2-recaptcha/ng2-recaptcha.js
// module id = ../../../../ng2-recaptcha/ng2-recaptcha.js
// module chunks = 3